import { useMemo } from "react";
import useStore from "../store/useStore";

export function useAllShows() {
  const apiShows = useStore((s) => s.apiShows);
  const customShows = useStore((s) => s.customShows);
  return useMemo(
    () => [...(apiShows || []), ...(customShows || [])],
    [apiShows, customShows]
  );
}

export function useShowById(id) {
  const apiShows = useStore((s) => s.apiShows);
  const customShows = useStore((s) => s.customShows);
  return useMemo(() => {
    if (!id) return null;
    return (
      (apiShows || []).find((s) => s.id === id) ||
      (customShows || []).find((s) => s.id === id) ||
      null
    );
  }, [id, apiShows, customShows]);
}
